import { z } from 'zod';
import { DashboardRole, Module } from './roles.js';

export const MeWorkspace = z.object({
  workspace_id: z.string(),
  client_conf_key: z.string(),
  name: z.string().nullable().optional(),
  modules: z.array(Module),
  suspended: z.boolean(),
  role: DashboardRole,
});
export type MeWorkspace = z.infer<typeof MeWorkspace>;

export const MeResponse = z.object({
  member_email: z.string().email(),
  name: z.string().nullable().optional(),
  user_type: z.string().nullable().optional(),
  super_admin: z.boolean(),
  workspaces: z.array(MeWorkspace),
});
export type MeResponse = z.infer<typeof MeResponse>;

export const LoginRequest = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const LoginResponse = z.object({
  ok: z.literal(true),
  member_email: z.string().email(),
});
export type LoginResponse = z.infer<typeof LoginResponse>;
